import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

const DashboardCouriersChart = ({ topCouriers }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    const labels = topCouriers.map((item) => item.supplier_name);
    const values = topCouriers.map((item) => item.parcel_count);

    const modernColors = [
      "#3a8dff", // Blue
      "#00c853", // Green
      "#ff9900", // Orange
      "#aa00ff", // Purple
      "#00b0ff", // Sky Blue
      "#f44336", // Red
    ];

    const chartData = {
      labels: labels,
      datasets: [
        {
          label: "Kargo Sayısı",
          data: values,
          backgroundColor: labels.map((_, i) => modernColors[i % modernColors.length]),
          borderRadius: 8,
          barThickness: 20,
        },
      ],
    };

    const chartOptions = {
      indexAxis: "y",
      aspectRatio: 1.8,
      scales: {
        x: {
          beginAtZero: true,
          grid: { 
            display: true,
            color: "rgba(0, 0, 0, 0.05)",
            drawBorder: false
          },
          ticks: { 
            maxTicksLimit: 10,
            callback: (value) => Math.round(value)
          },
        },
        y: {
          grid: { display: false },
          ticks: {
            font: {
              size: 11,
              weight: '500'
            }
          }
        },
      },
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        tooltip: {
          backgroundColor: 'rgba(31, 41, 55, 0.95)',
          titleFont: { size: 14, weight: 'bold' },
          bodyFont: { size: 13 },
          padding: 12,
          cornerRadius: 10,
          displayColors: true,
          boxWidth: 8,
          boxHeight: 8,
          boxPadding: 6,
          callbacks: {
            label: function(context) {
              return ` ${context.dataset.label}: ${context.parsed.x} Paket`;
            }
          }
        }
      },
    };

    if (chartRef.current && topCouriers && topCouriers.length > 0) {
      chartInstance.current = new Chart(chartRef.current, {
        type: "bar",
        data: {
          ...chartData,
          datasets: [{
            ...chartData.datasets[0],
            barThickness: 24,
            borderRadius: 6,
          }]
        },
        options: chartOptions,
      });
    }

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [topCouriers]);

  return (
    <div className="pie-chart">
      <div className="pie-chart-header">
        <div className="chart-header-left">
          <div className="shipment-count-icon-wrapper shipping">
            <LocalShippingIcon />
          </div>
          <div className="chart-header-text">
            <div className="pie-text-total">Favori Taşıyıcılarım</div>
          </div>
        </div>
      </div>
      <div style={{ height: "250px" }}>
        {topCouriers.length === 0 ? (
          <div className="no-data-text">Gönderiniz bulunmamaktadır.</div>
        ) : (
          <canvas ref={chartRef} />
        )}
      </div>
    </div>
  );
};

export default DashboardCouriersChart;

